<script setup lang="ts">
import { MAIN_COLOR } from "~/common/interfaces/main-color";

const props = defineProps({
	fill: {
		type: Boolean,
		default: false
	},
	color: {
		type: String,
		default: MAIN_COLOR.BLACK,
		validator (v: MAIN_COLOR) {
			return Object.values(MAIN_COLOR).includes(v);
		}
	},
	showLoading: {
		type: Boolean,
		default: false
	}
});

const colorSchemas: Record<string, any> = {
	black: {
		base: "text-black hover:bg-black hover:text-white",
		fill: "text-white bg-black",
		outline: "border border-black"
	},
	green: {
		base: "text-green hover:bg-green hover:text-white",
		fill: "text-white bg-green",
		outline: "border border-green"
	},
	orange: {
		base: "text-orange hover:bg-orange hover:text-white",
		fill: "text-white bg-orange",
		outline: "border border-orange"
	},
	pink: {
		base: "text-pink hover:bg-pink hover:text-white",
		fill: "text-white bg-pink",
		outline: "border border-pink"
	}
};

const currentColorSchema = computed(() => colorSchemas[props.color]);
const fillClasses = computed(() => props.fill
	? currentColorSchema.value.fill
	: currentColorSchema.value.base);
const outlineClasses = computed(() => props.fill || currentColorSchema.value.outline);
const buttonClasses = computed(() => [fillClasses.value, outlineClasses.value]);
</script>

<template>
	<button
		class="px-4 py-3 disabled:bg-gray disabled:text-white duration-100"
		:class="buttonClasses"
	>
		<div
			v-show="showLoading"
			class="flex justify-center gap-x-3 whitespace-nowrap uppercase"
		>
			<Icon name="eos-icons:loading" size="24" />
		</div>
		<div
			v-show="!showLoading"
			class="whitespace-nowrap uppercase"
		>
			<slot></slot>
		</div>
	</button>
</template>
